import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/auth.context';
import { SessionLoadingFallback } from '@/components/auth/SessionLoadingFallback';
import { CHANGE_PASSWORD_ROUTE, LOGIN_ROUTE } from '@/lib/auth-routes';

const ProtectedRoute = () => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return <SessionLoadingFallback />;
  }

  if (!isAuthenticated) {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }

  if (user?.must_change_password) {
    return <Navigate to={CHANGE_PASSWORD_ROUTE} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute; 
